// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"7ca5b9b2","286":"58e8d4d6","453":"5e560239"}[chunkId] + ".chunk.js";
};